import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonashikcabs() {



const cardData =
{
  keyword: 'Pune to Nashik Cabs',
  heading: 'Lotus Cab: Pune to Nashik Cabs',
  headingDescription: 'Lotus Cab provides professional and highly reliable Pune to Nashik Cabs service designed for comfortable, safe, and stress-free intercity travel. Whether you are planning a pilgrimage to Trimbakeshwar Jyotirlinga, a wine tour to Sula Vineyards, a corporate visit, or a relaxing family getaway, our premium sedan and SUV fleet ensures smooth highway travel. The Pune–Nashik route is frequently used for business, tourism, and spiritual journeys, and our experienced chauffeurs are well-trained in long-distance driving, alternate highway routes, and safety protocols. We offer flexible one-way and round-trip cab options with transparent per-kilometer pricing and no hidden charges. Our vehicles are fully air-conditioned, regularly sanitized, and maintained to provide maximum passenger comfort. With punctual pickup across Pune, professional customer support, and 24/7 booking availability, Lotus Cab guarantees a seamless Pune to Nashik taxi experience tailored to your travel needs.',

  top: 'Top Places to Visit in Nashik with Lotus Cab',

  "topPlaces": [
    {
      "title": "Trimbakeshwar Temple",
      "description": "Trimbakeshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and a major pilgrimage center near Nashik. Devotees travel from Pune to seek blessings and perform religious rituals. The temple’s spiritual significance and serene surroundings attract visitors year-round. Lotus Cab ensures timely darshan visits with comfortable highway travel."
    },
    {
      "title": "Sula Vineyards",
      "description": "Sula Vineyards is India’s most famous wine tourism destination, offering vineyard tours and scenic landscapes. Visitors from Pune frequently book cabs for weekend wine tours. Lotus Cab provides safe and relaxed travel for leisure trips."
    },
    {
      "title": "Panchavati",
      "description": "Panchavati holds mythological importance in the Ramayana and is a sacred area for devotees. Travelers often book darshan cab services for temple visits. Lotus Cab ensures comfortable travel for spiritual journeys."
    },
    {
      "title": "Anjneri Hills",
      "description": "Anjneri Hills, believed to be the birthplace of Lord Hanuman, is popular among trekkers. Nature lovers and adventure enthusiasts visit this scenic location. Lotus Cab offers reliable transportation to trekking base points."
    },
    {
      "title": "Ramkund",
      "description": "Ramkund is a sacred bathing ghat on the Godavari River and an important religious site in Nashik. Pilgrims travel from Pune for rituals and spiritual ceremonies."
    },
    {
      "title": "Pandavleni Caves",
      "description": "These ancient Buddhist caves date back to the 1st century BC and are a historical attraction. Lotus Cab provides safe outstation taxi service for heritage exploration."
    },
    {
      "title": "Muktidham Temple",
      "description": "Muktidham Temple is known for its marble architecture and replicas of Jyotirlingas. Visitors prefer comfortable cab travel for temple visits."
    },
    {
      "title": "Coin Museum",
      "description": "The Coin Museum in Nashik showcases India’s numismatic history and attracts history enthusiasts."
    },
    {
      "title": "Harihar Fort",
      "description": "Harihar Fort is famous for its steep rock-cut steps and trekking trails. Adventure travelers book SUV cabs for convenient access."
    },
    {
      "title": "Someshwar Waterfall",
      "description": "Someshwar Waterfall is a scenic monsoon attraction ideal for family outings and nature photography."
    }
  ],

  "services": [
    {
      "name": "Pune to Nashik Cabs",
      "description": "Book Pune to Nashik Cabs with Lotus Cab for safe, comfortable, and professionally managed intercity transportation. Our AC sedan and SUV fleet ensures smooth highway travel with experienced drivers trained for long-distance journeys. Transparent pricing and punctual pickup make your travel stress-free."
    },
    {
      "name": "Pune to Nashik Taxi Service",
      "description": "Our Pune to Nashik Taxi Service offers reliable one-way and round-trip travel options with flexible scheduling and clean vehicles."
    },
    {
      "name": "Pune to Nashik One Way Cab",
      "description": "Affordable one-way cab option allowing customers to pay only for the distance traveled without return charges."
    },
    {
      "name": "Pune to Nashik Round Trip Taxi",
      "description": "Flexible round-trip cab service with return scheduling based on your convenience."
    },
    {
      "name": "Pune to Nashik Outstation Cab",
      "description": "Comfortable outstation cab service for long-distance travel with highway-experienced drivers."
    },
    {
      "name": "Pune to Nashik Darshan Cab",
      "description": "Special darshan cab service for temple visits including Trimbakeshwar and Panchavati."
    },
    {
      "name": "Affordable Pune to Nashik Cab",
      "description": "Budget-friendly pricing with transparent billing and no hidden charges."
    },
    {
      "name": "Luxury Taxi Pune to Nashik",
      "description": "Premium luxury sedan and SUV options for executive and VIP travel."
    },
    {
      "name": "SUV Cab Pune to Nashik",
      "description": "Spacious SUV vehicles ideal for families and group travel."
    },
    {
      "name": "Best Pune to Nashik Cab Service",
      "description": "Top-rated intercity cab service known for punctuality, comfort, and safety."
    }
  ],

  "tableData": [
    ["Pune to Nashik Cabs", "Pune to Nashik Taxi Service"],
    ["Pune to Nashik One Way Cab", "Pune to Nashik Round Trip Taxi"],
    ["Pune to Nashik Outstation Cab", "Pune to Nashik Darshan Cab"],
    ["Affordable Pune to Nashik Cab", "Luxury Taxi Pune to Nashik"],
    ["SUV Cab Pune to Nashik", "Cheap Pune to Nashik Taxi"],
    ["Online Pune to Nashik Cab Booking", "Best Pune to Nashik Cab Service"],
    ["Pune to Nashik Night Travel Cab", "Pune to Nashik Corporate Taxi"],
    ["Pune to Nashik Family Trip Cab", ""]
  ],

  "whychoose": [
    { "WhyChooseheading": "Highway Experienced Drivers", "WhyChoosedescription": "Our chauffeurs are trained for long-distance highway driving ensuring safety and punctuality." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "No hidden charges with clear fare breakdown before booking." },
    { "WhyChooseheading": "Flexible Travel Options", "WhyChoosedescription": "Choose between one-way and round-trip packages." },
    { "WhyChooseheading": "Comfortable Fleet", "WhyChoosedescription": "AC sedans and spacious SUVs for comfortable travel." },
    { "WhyChooseheading": "24/7 Support", "WhyChoosedescription": "Round-the-clock booking and travel assistance." },
    { "WhyChooseheading": "Darshan Special Service", "WhyChoosedescription": "Timely temple visits with route familiarity." },
    { "WhyChooseheading": "Corporate Travel Ready", "WhyChoosedescription": "Professional service for business travelers." },
    { "WhyChooseheading": "Safe Night Travel", "WhyChoosedescription": "Secure and verified drivers for night journeys." }
  ]
}

const faqData = [
  { question: 'Do you offer one-way cab from Pune to Nashik?', answer: 'Yes, we provide affordable one-way travel option.' },
  { question: 'Is round-trip service available?', answer: 'Yes, flexible round-trip packages are available.' },
  { question: 'Are fares transparent?', answer: 'Yes, pricing is shared before confirmation.' },
  { question: 'Do you provide darshan cab?', answer: 'Yes, special temple travel service is available.' },
  { question: 'Is SUV available?', answer: 'Yes, SUV and sedan options are available.' },
  { question: 'Is night travel safe?', answer: 'Yes, drivers are verified and trained.' },
  { question: 'Can I book online?', answer: 'Yes, online booking available.' },
  { question: 'Are vehicles AC?', answer: 'Yes, all vehicles are air-conditioned.' },
  { question: 'Do you offer corporate billing?', answer: 'Yes, corporate packages available.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, advance booking ensures availability.' }
];

const testimonials = [
  { id: 1, name: 'Mr. Prakash Joshi', feedback: 'Very smooth Pune to Nashik trip for Trimbakeshwar darshan. Driver was polite and professional.', rating: 5 },
  { id: 2, name: 'Mrs. Neeta Sharma', feedback: 'Comfortable family trip to Nashik vineyards. Clean car and transparent pricing.', rating: 5 }
];










































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nashik Cabs",
  "image": "https://lotuscab.com/assets/images/pune-to-nashik-cabs.jpg", 
  "description": "Lotus Cab offers Pune to Nashik cabs with affordable one way and round trip taxi service. Book sedan, SUV and luxury outstation cabs for Nashik darshan, corporate travel, night journeys and family trips with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-nashik-cabs"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune to Nashik Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Nashik cabs with Lotus Cab. Affordable one way & round trip taxi service for darshan, corporate & family trips. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Nashik Cabs, Pune to Nashik Taxi Service, Pune to Nashik One Way Cab, Pune to Nashik Round Trip Taxi, Pune to Nashik Outstation Cab, Pune to Nashik Darshan Cab, Affordable Pune to Nashik Cab, Luxury Taxi Pune to Nashik, SUV Cab Pune to Nashik, Cheap Pune to Nashik Taxi, Online Pune to Nashik Cab Booking, Best Pune to Nashik Cab Service, Pune to Nashik Night Travel Cab, Pune to Nashik Corporate Taxi, Pune to Nashik Family Trip Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonashikcabs;